import React, { useEffect, useState } from 'react';
import { Button, Row, Col } from 'reactstrap';
import { api, globalErrorHandler } from '../../api/create-api';
import { useToasts } from 'react-toast-notifications';
import { EMPTY_GUID } from '../../Helpers/Helper';
import { makeCall } from '../../auth-utils.js';
import { AppName } from '../../App';
import { PropertyList } from '../Shared/PropertyList';

const RegisterUser = (props) => {
    const { RecheckAccess } = props;
    const { addToast, removeToast } = useToasts();
    const [hasRegistered, setHasRegistered] = useState(false);
    const [resource, setResource] = useState({ ...props.user, role: 'user' });
    const isRegistered = resource.id !== EMPTY_GUID;
    const [resourceIsDirty, setResourceIsDirty] = useState(false);

    useEffect(() => setResource({ ...props.user, role: 'user' }), [props.user]);

    const registerUser = () => {
        makeCall(async (authHeader) => {
            let registered = true;
            addToast('Registering...', { appearance: 'info', id: 'registering-user' });
            await api.post(`api/users/`, resource, {
                headers: { ...authHeader }
            })
                .catch((error) => {
                    registered = false;
                    globalErrorHandler(error, addToast)
                });

            removeToast('registering-user', () => {
                if (registered) {
                    setHasRegistered(true);
                    if (RecheckAccess && typeof RecheckAccess === 'function') {
                        RecheckAccess();
                    }
                }
            });
        });
    };

    const updateResource = (e) => {
        setResource({
            ...resource,
            [e.target.name]: e.target.value
        });

        setResourceIsDirty(true);
    };

    return (isRegistered ?
        <div className="text-left">
            <strong>{resource.name}</strong>, you've already been registered to be a user of {AppName}. Unfortunately, the admin users haven't assigned your access yet.
        </div>
        : hasRegistered ?
            <div>
                <p>Registered! Now redirecting to {AppName}!</p>
            </div>
            :
            <Row>
                <Col>
                    <p>Unfortunately, <strong>{resource.name}</strong>, you don't currently have access to {AppName}. Would you like to register?</p>
                </Col>
                <Col sm={{ size: 9, offset: 3 }} md={{ size: 7, offset: 5 }} xl={{ size: 5, offset: 7 }}>
                    <PropertyList
                        Label="Request Access"
                        SearchLabel="Search for a Community"
                        HideList
                        HideButtons
                        parentRecord={resource}
                        selectedProperties={resource.assets || []}
                        selectedField="assets"
                        UpdatePropertyAccess={(selected) => updateResource({ target: { name: selected.field, value: selected.value } })}
                    />
                    <div><span className="text-dark">Please select</span> all communities <span className="text-dark">to which you need access.</span></div>
                    <div className="text-right mt-2">
                        {(!resource.assets || resource.assets.length === 0) && <span className="text-danger mr-1">Please select a community.</span>}
                        <Button color="success" onClick={registerUser} disabled={!resource.assets || resource.assets.length === 0}>Register</Button>
                    </div>
                </Col>
            </Row>
    );
};

export default RegisterUser;


// WEBPACK FOOTER //
// ./src/components/Users/RegisterUser.js